import Dict from '@/utils/dict-utils'

// 公司类型
export const companyTypeDict = new Dict({
  ENTERPRISE: { value: 1, label: '企业', icon: 'icon-enterprise' },
  PUBLIC_INSTITUTION: { value: 2, label: '事业单位', icon: 'icon-institution' },
  SELF_EMPLOYEE: { value: 3, label: '个体工商户', icon: 'icon-self-employee' },
  PERSON: { value: 4, label: '自然人', icon: 'icon-person' }
})

// 身份认证状态
export const serviceCertifiedDict = new Dict({
  YES: { value: 1, label: '已开通' },
  NO: { value: 0, label: '未开通' }
})

// 是否认证了公司信息
export const isCertifiedDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 是否办理了CA证书
export const caStatusDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 公司状态
export const companyStatusDict = new Dict({
  NORMAL: { value: 1, label: '正常' },
  FORBIDDEN: { value: 0, label: '禁用' }
})

// 公司认证状态字典
export const companyCertifiedDict = new Dict({
  PENDING: { value: 0, label: '审核中', type: 'primary' },
  PASS: { value: 1, label: '已开通', type: 'success' },
  REJECT: { value: 2, label: '驳回', type: 'danger' }
})

// 未认证情况下，首页审核状态字典
export const companyRoleAuditStatusHomeDict = new Dict({
  TO_AUDIT: { value: 0, label: '待审核' },
  AUDITING: { value: 1, label: '未认证' },
  REFUSE: { value: 2, label: '审核未通过' }
})

// 公司信息是否可以修改
export const canCompanyInfoBeChangedDict = new Dict({
  NOT_AT_ALL: { value: 1, label: '完全不可修改' },
  PART: { value: 2, label: '部分可以修改' },
  ALL: { value: 3, label: '全部可以修改' }
})

// 部门类型
export const departmentTypeDict = new Dict({
  DEPARTMENT: { value: 1, label: '本级部门' },
  SUBSIDIARY: { value: 2, label: '下属公司' }
})

// 公司关联状态
export const subsidiaryConnectStatusDict = new Dict({
  IN_CONNECT: { value: 0, label: '关联中', type: 'primary' },
  CONNECTED: { value: 1, label: '已关联', type: 'success' },
  REJECT_CONNECT: { value: 2, label: '已拒绝', type: 'danger' },
  IGNORE_CONNECT: { value: 3, label: '已拒绝', type: 'danger' }
})

// 关联类型
export const associationTypeDict = new Dict({
  CHILD: { value: 1, label: '关联子公司' },
  PARENT: { value: 2, label: '关联父公司' }
})

// 企业规模
export const companyScaleDict = new Dict({
  1: { value: 1, label: '1-50' },
  2: { value: 2, label: '51-100' },
  3: { value: 3, label: '101-300' },
  4: { value: 4, label: '301-500' },
  5: { value: 5, label: '501-1000' },
  6: { value: 6, label: '1000以上' }
})

// 企业所属行业
export const companyIndustryDict = new Dict({
  1: { value: 1, label: '农产品' },
  2: { value: 2, label: '能源(石油/石化/煤炭/新能源)' },
  3: { value: 3, label: '食品饮料烟草' },
  4: { value: 4, label: '纺织服装皮革' },
  5: { value: 5, label: '包装' },
  6: { value: 6, label: '工艺礼品玩具' },
  7: { value: 7, label: '化工' },
  8: { value: 8, label: '医药' },
  9: { value: 9, label: '五金' },
  10: { value: 10, label: '电子' },
  11: { value: 11, label: '机械设备' },
  12: { value: 12, label: '交通运输' },
  13: { value: 13, label: '办公用品' },
  14: { value: 14, label: '仪器仪表' },
  15: { value: 15, label: 'IT、通讯及信息技术' },
  16: { value: 16, label: '工程建筑行业' },
  17: { value: 17, label: '安全防护' },
  18: { value: 18, label: '传媒、广电' },
  19: { value: 19, label: '家居行业' },
  20: { value: 20, label: '橡胶塑胶' },
  21: { value: 21, label: '印刷' },
  22: { value: 22, label: '冶金矿产' },
  23: { value: 23, label: '家用电器' },
  24: { value: 24, label: '电气' },
  25: { value: 25, label: '建筑建材' },
  26: { value: 26, label: '电力' },
  27: { value: 27, label: '运动、休闲' },
  28: { value: 28, label: '居民服务和其它服务业' },
  29: { value: 29, label: '商业贸易(综合类企业)' },
  30: { value: 30, label: '纸业' },
  31: { value: 31, label: '物流运输' },
  32: { value: 32, label: '通信及信息服务' },
  33: { value: 33, label: '批发零售、住宿餐饮' },
  34: { value: 34, label: '金融保险' },
  35: { value: 35, label: '房产物业' },
  36: { value: 36, label: '租赁和商务服务' },
  37: { value: 37, label: '科研技术和地质勘查' },
  38: { value: 38, label: '水利、环境和公共设施管理' },
  39: { value: 39, label: '文化、教育、体育、娱乐服务' },
  40: { value: 40, label: '卫生、社会保障福利' },
  41: { value: 41, label: '国际、社会组织与公共管理' },
  42: { value: 42, label: '出版印刷' },
  43: { value: 43, label: '软件服务' },
  44: { value: 44, label: '咨询培训' },
  45: { value: 45, label: '维护清洗' },
  46: { value: 46, label: '会展服务' },
  47: { value: 47, label: '代理经营' },
  48: { value: 48, label: '网络通信' },
  49: { value: 49, label: '其他服务' },
  50: { value: 50, label: '环保设备' }
})

// 企业（服务）类型
export const companyServiceTypeDict = new Dict({
  1: { value: 1, label: '生产型' },
  2: { value: 2, label: '贸易型' },
  3: { value: 3, label: '服务型' }
})

// 企业性质
export const companyNatureDict = new Dict({
  1: { value: 1, label: '国有独资企业' },
  2: { value: 2, label: '国有绝对控股企业' },
  3: { value: 3, label: '国有相对控股企业' },
  4: { value: 4, label: '港、澳、台投资企业' },
  5: { value: 5, label: '外商投资企业' },
  6: { value: 6, label: '公共管理和社会组织' },
  7: { value: 7, label: '私营企业' },
  8: { value: 8, label: '事业单位' },
  9: { value: 9, label: '军队' },
  10: { value: 10, label: '中外合资' },
  11: { value: 11, label: '其他' }
})

// 事业单位分类
export const publicInstitutionNatureDict = new Dict({
  1: { value: 1, label: '教育事业单位' },
  2: { value: 2, label: '科技事业单位' },
  3: { value: 3, label: '文化事业单位' },
  4: { value: 4, label: '卫生事业单位' },
  5: { value: 5, label: '社会福利事业单位' },
  6: { value: 6, label: '体育事业单位' },
  7: { value: 7, label: '交通事业单位' },
  8: { value: 8, label: '城市公用事业单位' },
  9: { value: 9, label: '农林牧渔水事业单位' },
  10: { value: 10, label: '信息咨询事业单位' },
  11: { value: 11, label: '中介服务事业单位' },
  12: { value: 12, label: '勘察设计事业单位' },
  13: { value: 13, label: '地震测防事业单位' },
  14: { value: 14, label: '海洋事业单位' },
  15: { value: 15, label: '环境保护事业单位' },
  16: { value: 16, label: '检验检测事业单位' },
  17: { value: 17, label: '知识产权事业单位' },
  18: { value: 18, label: '机关后勤服务事业单位' },
  19: { value: 19, label: '其它类' }
})

// 费用科目
export const costSubjectDict = new Dict({
  REGISTER_FEE: {
    value: 1,
    label: '平台使用费'
  },
  SERVICE_FEE: {
    value: 2,
    label: '服务费'
  },
  BOND: {
    value: 3,
    label: '保证金'
  },
  TENDER_FEE: {
    value: 4,
    label: '标书费'
  },
  AGENCY_SERVICE_FEE: {
    value: 5,
    label: '代理服务费'
  }
})

export const agentCollectTypeDict = new Dict({
  OFFLINE: {
    value: 0,
    label: '线下收取'
  },
  ONLINE: {
    value: 1,
    label: '线上收取'
  }
})

// 收费主体
export const chargeSubjectDict = new Dict({
  COMPANY: {
    value: 1,
    label: '采购机构'
  },
  PLATFORM: {
    value: 2,
    label: '平台'
  }
})

// 收费方式
export const chargeTypeDict = new Dict({
  COMPANY: {
    value: 1,
    label: '发布设置'
  },
  CHARGE: {
    value: 2,
    label: '计费设置'
  },
  FREE: {
    value: 3,
    label: '不收费'
  }
})

// 计费模式
export const billingModelDict = new Dict({
  FIXED_FORMULA: {
    value: 1,
    label: '固定公式'
  },
  INTERVAL_CHARGING: {
    value: 2,
    label: '区间计费'
  },
  ACCUMULATED_DIFF: {
    value: 3,
    label: '差额累进'
  }
})

// 计算项类型
export const expTypeDict = new Dict({
  BASE: {
    value: 1,
    label: '基础指标'
  },
  SYMBOL: {
    value: 2,
    label: '符号'
  },
  CUSTOM: {
    value: 3,
    label: '自定义项'
  }
})

export const baseIndexDict = new Dict({
  BUDGET_AMOUNT: {
    type: expTypeDict.BASE.value,
    label: '项目总预算',
    value: 'budgetAmount'
  },
  WINNER_AMOUNT: {
    type: expTypeDict.BASE.value,
    label: '项目总成交金额',
    value: 'winnerAmount'
  }
})

// 公司证件上传状态
export const certificateUploadStatusDict = new Dict({
  YES: {
    value: 1,
    label: '已上传',
    type: 'primary'
  },
  NO: {
    value: 0,
    label: '未上传',
    type: 'danger'
  }
})

// 绑卡状态
export const bindingCardStatusDict = new Dict({
  YES: {
    value: 1,
    label: '已绑卡',
    type: 'success'
  },
  NO: {
    value: 0,
    label: '未绑卡',
    type: 'info'
  }
})

// 开户状态
export const accountStatusDict = new Dict({
  YES: {
    value: 1,
    label: '已创建'
  },
  NO: {
    value: 0,
    label: '未创建'
  }
})

/**
 * 应用开通状态
 * @type {Dict}
 * @property {Object} SAVED 已保存
 * @property {Object} PENDING 待审核
 * @property {Object} OPENED 已开通
 * @property {Object} REJECTED 驳回
 */
export const appStatusDict = new Dict({
  /**
   * 已保存
   */
  SAVED: {
    label: '已保存',
    value: 0,
    type: 'info',
    permission: ['continue', 'remove']
  },
  /**
   * 待审核
   */
  PENDING: {
    label: '待审核',
    value: 1,
    type: 'primary',
    permission: ['look']
  },
  /**
   * 已开通
   */
  OPENED: {
    label: '已开通',
    value: 2,
    type: 'success',
    permission: ['look']
  },
  /**
   * 驳回
   */
  REJECTED: {
    label: '驳回',
    value: 3,
    type: 'danger',
    permission: ['change']
  }
})

/**
 * 数据源
 */
export const companyLevelTypeDict = new Dict({
  THIS_LEVEL: { label: '本企业', value: 0, statLabel: '统计本级企业' },
  THIS_AND_SUBORDINATE: {
    label: '本企业及下级企业',
    value: 1,
    statLabel: '统计含本级企业和子级企业'
  }
})
